<template>
  <font-awesome-icon :class="styles" :icon="icon" />
</template>

<script>
export default {
  name: 'Icon',
  props: ['styles', 'type'],

  data() {
    return {};
  },
  computed: {
    icon() {
      switch(this.type) {
          case 'backButton' :
            return ['fas', 'chevron-left'];

          case 'nextButton' :
            return ['fas', 'chevron-right'];    
            
          case 'close' :
            return ['fas', 'times'];    

      }
      return ['fas', 'question'];
    },
  },
};
</script>

<style></style>
